import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PathConstants } from './util/path.constants';
// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: PathConstants.PATH_EMPTY,
    redirectTo: PathConstants.FULLPATH_PAGINA_INICIO,
    pathMatch: 'full'
  },
  {
    path: PathConstants.PATH_SECURITY,
    component: SimpleLayoutComponent,
    loadChildren: './views/security/security.module#SecurityModule',

  },
  {
    path: PathConstants.PATH_ADMIN,
    component: FullLayoutComponent,
    data: {
      title: 'Administración'
    },
    children: [

      { path: PathConstants.PATH_AHORROS, data: { title: 'Ahorros' }, loadChildren: './views/administration/ahorros/ahorros.module#AhorrosModule' },
      { path: PathConstants.PATH_BANNERES, data: { title: 'Banneres' }, loadChildren: './views/administration/banneres/banneres.module#BanneresModule' },
      { path: PathConstants.PATH_CALENDARIOS, data: { title: 'Calendarios' }, loadChildren: './views/administration/calendarios/calendarios.module#CalendariosModule' },
      { path: PathConstants.PATH_CREDITOS, data: { title: 'Creditos' }, loadChildren: './views/administration/creditos/creditos.module#CreditosModule' },
      { path: PathConstants.PATH_EMPRESASES, data: { title: 'Empresases' }, loadChildren: './views/administration/empresases/empresases.module#EmpresasesModule' },
      { path: PathConstants.PATH_EVENTOS, data: { title: 'Eventos' }, loadChildren: './views/administration/eventos/eventos.module#EventosModule' },
      { path: PathConstants.PATH_FOTOS, data: { title: 'Fotos' }, loadChildren: './views/administration/fotos/fotos.module#FotosModule' },
      { path: PathConstants.PATH_MEDICOS, data: { title: 'Medicos' }, loadChildren: './views/administration/medicos/medicos.module#MedicosModule' },
      { path: PathConstants.PATH_NOTICIAS, data: { title: 'Noticias' }, loadChildren: './views/administration/noticias/noticias.module#NoticiasModule' },
      { path: PathConstants.PATH_PARTICIPANTES, data: { title: 'Participantes' }, loadChildren: './views/administration/participantes/participantes.module#ParticipantesModule' },
      { path: PathConstants.PATH_DOCUMENTOS, data: { title: 'Documentos' }, loadChildren: './views/administration/documentos/documentos.module#DocumentosModule' },
      { path: PathConstants.PATH_DATOS, data: { title: 'Datos' }, loadChildren: './views/administration/datos/datos.module#DatosModule' },
      { path: PathConstants.PATH_BIENESTARES, data: { title: 'Bienestares' }, loadChildren: './views/administration/bienestares/bienestares.module#BienestaresModule' },


    ]
  },
  {
    path: PathConstants.PATH_HOME,
    component: SimpleLayoutComponent,
    loadChildren: './views/pagina/pagina.module#PaginaModule',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts